export default "__VITE_ASSET__upxHEArX__"